import styled from "styled-components";
import { SideMenuComponentBox } from "../../side-menu/boxes/side-menu-component.box";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

export const ProfileWrapperDefaultBox = styled(SideMenuComponentBox)`
    margin: 4rem 0 0 0;
`;


const ProfileWrapperMrGreenBox = styled(ProfileWrapperDefaultBox)`
    margin: 5rem 0 0 0;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    background: radial-gradient(circle at top, transparent 0, transparent 3.4rem, ${({theme}) => theme.colors.backgroundDark} 3.4rem, ${({theme}) => theme.colors.backgroundDark} 100%);
`;


export const ProfileWrapperBox = styledByTheme(ProfileWrapperDefaultBox)
    .forMrGreen(ProfileWrapperMrGreenBox)
    .apply();